import React from 'react';
import { AccessibilityButton } from '@skillz/accessibility';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sendEvent } from "../../../utils/analytics/ga4";
import Tooltip from '../tooltip/Tooltip';
import changeArrows from '../../../../assests/icons/changeArrows.svg'
import classes from './OldViewBtn.module.css';

const OldViewBtn = ({ text, className, isIframeRoute }) => {

    const { user } = useSelector(state => state.auth);
    const location = useLocation();

    const handleOldView = () => {
        sendEvent("back_to_old_vc_app", { exidentifier: user.exidentifier })
        const { pathname, search, hash } = location;
        window.location.href = `${window.config.oldVirtualCampusUrl}${pathname}${search}${hash}`;
    }

    return (
        <AccessibilityButton className={`${classes.OldViewBtn} ${className} ${isIframeRoute ? classes.IframeRoute : ''}`} onClick={handleOldView} >
            <Tooltip showTooltip={true} text={text} position="LeftCenter">
                <div className={classes.Content}>
                    <img src={changeArrows} alt="changeArrows" className={classes.Img} />
                    <p className={classes.OldViewBtnText}>{text}</p>
                </div>
            </Tooltip>
        </AccessibilityButton>
    )
}
export default OldViewBtn;